import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  inviteLandlord,
  inviteUser,
  getInviteProperty,
  getInvitePropertyPerUser,
} from './APIs/invite';
import types from '../constants/inviteConstants';
import { successNotif, failedNotif, getNotifToAction } from '../actions/notifActions';
import { setLoading } from '../actions/authActions';
import { getEmailAction } from '../actions/emailActions';
import { getInvitePropertyAction, setInvitePropertyAction } from '../actions/inviteActions';
import { getApiErrorMessage } from 'utils/apiError';
import { formatInviteSuccessMessage } from 'utils/notificationMessage';

function* inviteLandlordSaga({ payload }) {
  try {
    yield put(setLoading(true));
    yield put(successNotif(null));
    yield put(failedNotif(null));
    const response = yield inviteLandlord(payload);
    yield put(successNotif(formatInviteSuccessMessage(response)));
  } catch (error) {
    yield put(
      failedNotif(
        getApiErrorMessage(error, 'Failed to send operator invitation. Please try again.'),
      ),
    );
  } finally {
    yield put(setLoading(false));
  }
}

function* onInviteLandlord() {
  yield takeLatest(types.INVITE_LANDLORD, inviteLandlordSaga);
}

function* inviteUserSaga({ payload }) {
  try {
    yield put(setLoading(true));
    yield put(successNotif(null));
    yield put(failedNotif(null));

    const res = yield inviteUser(payload);
    yield put(successNotif(formatInviteSuccessMessage(res)));

    if (payload.type === 'resend-email') {
      yield put(getEmailAction());
    } else if (payload.type === 'resend-request') {
      yield put(getNotifToAction());
    } else {
      const refreshPayload = { inviteRole: payload.userRole };
      if (payload.landlordId) {
        refreshPayload.landlordId = payload.landlordId;
      }
      yield put(getInvitePropertyAction(refreshPayload));
    }
  } catch (error) {
    yield put(
      failedNotif(getApiErrorMessage(error, 'Failed to send invitation. Please try again.')),
    );
  } finally {
    yield put(setLoading(false));
  }
}

function* onInviteUser() {
  yield takeLatest(types.INVITE_USER, inviteUserSaga);
}

function* getInvitePropertySaga({ payload }) {
  try {
    const property = yield getInviteProperty(payload);
    yield put(setInvitePropertyAction(property));
  } catch (error) {
    yield put(setInvitePropertyAction({ data: [], total: 0 }));
    yield put(failedNotif(getApiErrorMessage(error, 'Failed to load invite properties.')));
  }
}

function* onGetInviteProperty() {
  yield takeLatest(types.GET_INVITE_PROPERTY, getInvitePropertySaga);
}

function* getInvitePropertyPerUserSaga({ payload }) {
  try {
    const result = yield getInvitePropertyPerUser(payload);
    yield put(setInvitePropertyAction(result));
  } catch (error) {
    yield put(failedNotif(getApiErrorMessage(error, 'Failed to load user properties.')));
  }
}

function* onGetInvitePropertyPerUser() {
  yield takeLatest(types.GET_INVITE_PROPERTY_PER_USER, getInvitePropertyPerUserSaga);
}

export default function* inviteSaga() {
  yield all([
    call(onInviteLandlord),
    call(onInviteUser),
    call(onGetInviteProperty),
    call(onGetInvitePropertyPerUser),
  ]);
}
